export var name = 'ranking';
export var MANUAL_PAY = 'M';
export var DIRECT_PAY = 'D';
